import React from "react";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import "./Count.css";

const Count = ({ days = 0, hours = 0, minutes = 0, seconds = 0 }) => {
  const timeUnits = [
    { value: days, label: "DAYS", pad: days < 10 },
    { value: hours, label: "HOURS", pad: hours < 10 },
    { value: minutes, label: "MINUTES", pad: minutes < 10 },
    { value: seconds, label: "SECONDS", pad: seconds < 10 },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", sm: "900px", md: "1000px" },
        margin: "0 auto",
        padding: { xs: "0 10px", sm: "0 20px" },
      }}
    >
      <Grid
        container
        spacing={{ xs: 2, sm: 3, md: 4 }}
        justifyContent="center"
        alignItems="center"
      >
        {timeUnits.map((unit, index) => (
          <React.Fragment key={unit.label}>
            <Grid item xs={5} sm={2.5} md={2.5}>
              <Box className="countdown-card">
                <Box className="countdown-number">
                  {unit.pad ? `0${unit.value}` : unit.value}
                </Box>
                <Typography className="countdown-label" variant="body2">
                  {unit.label}
                </Typography>
              </Box>
            </Grid>
            {index < timeUnits.length - 1 && (
              <Grid
                item
                xs={1}
                sm={0.5}
                sx={{
                  display: { xs: index % 2 === 0 ? "flex" : "none", md: "flex" },
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box className="countdown-separator">:</Box>
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};

export default Count;
